import { render, staticRenderFns } from "./PartnershipManage.vue?vue&type=template&id=97870f7c&"
import script from "./PartnershipManage.vue?vue&type=script&lang=js&"
export * from "./PartnershipManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports